import CoordinateSystem from './components/coordinate_system/coordinate_system';

function App() {

  return (
    <div className="App">
      <CoordinateSystem />
    </div>
  );
}

export default App;